import { createServerFn } from "@tanstack/react-start";

import { setRouteAction } from "#/lib/requestLogger.server";
import { emptyServerInputSchema } from "#/lib/serverInputSchemas";
import { authedMiddleware } from "#/server/authedMiddleware";
import { shapeOwnPlayerProfile, type PlayerProfile } from "#/server/playerProfileShape";

export const getMyPlayerProfile = createServerFn({ method: "GET" })
  .middleware([authedMiddleware])
  .validator(emptyServerInputSchema)
  .handler(async ({ context }): Promise<PlayerProfile> => {
    setRouteAction("get_player_profile");
    return shapeOwnPlayerProfile(context.player);
  });
